



































import ModalContainer from "@/components/ModalContainer.vue";
import { defineComponent, reactive } from "@vue/composition-api";
import { QBtn } from "quasar";

export default defineComponent({
  name: "TermsDialog",
  components: { QBtn, ModalContainer },
  props: {
    show: Boolean,
    terms: Array,
  },
  setup(p, ctx) {
    return reactive({
      agreeToTerms: () => ctx.emit("agree", true),
      close: () => ctx.emit("update:show", false),
    });
  },
});
